import CTLUnReadCell from "application/components/CTLUnReadCell";
import DefaultCell from "application/components/DefaultCell";
import RupeeCell from "application/components/RupeeCell";
import { BillingReportMenu } from "globals/configuration/BillingReportMenu";

const Attributes = {
  enableAddButton: false,
  enableUpdateTableRecords: true,
  enableDownloadButton: true,
  enableAdvanceSearch: true,
  enableDownloadPdf: true,
  enableRefresh: true,
  modes: BillingReportMenu.map((item) => ({
        id: item.key,
        name: item.name,
        iconName: item.icon,
        url: item.url,
        description: item.description,
        disabled: item.disabled,
        productionReady: item.productionReady,
      })),
};

const operationURLS = {
  list: "/billingCDRDepartment/summary/list",
  pdfDownload: "/billingCDRDepartment/summary/generateAndDownloadPdf",
  csvDownload: "/billingCDRDepartment/summary/downloadCSV",
};

const getColumns = () => {
  return [
    {
      Header: "Department Code",
      accessor: "departmentCode",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Department Name",
      accessor: "departmentName",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Caller Name",
      accessor: "callerName",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Caller Number",
      accessor: "callerIdNumber",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Intercom Call",
      accessor: "intercomCall",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Intercom Cost(INR)",
      accessor: "intercomCost",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      Cell: ({ value }) => <RupeeCell value={value} />,
    },
    {
      Header: "Local Call",
      accessor: "localCall",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Local Cost(INR)",
      accessor: "localCost",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      Cell: ({ value }) => <RupeeCell value={value} />,
    },
    {
      Header: "STD Call",
      accessor: "stdCall",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "STD Cost(INR)",
      accessor: "stdCost",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      Cell: ({ value }) => <RupeeCell value={value} />,
    },
    {
      Header: "ISD Call",
      accessor: "isdCall",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "String",
      sortDisable: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "ISD Cost(INR)",
      accessor: "isdCost",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "Integer",
      sortDisable: true,
      Cell: ({ value }) => <RupeeCell value={value} />,
    },
    {
      Header: "Total Call",
      accessor: "totalCall",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Total Cost(INR)",
      accessor: "totalCost",
      displayInList: true,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      Cell: ({ value }) => <RupeeCell value={value} />,
    },
  ];
};

export { getColumns, Attributes, operationURLS };
